// 节流
export const throttle = (fn, t) => {
  let prev = Date.now();
  // 下面是个闭包，可以一直获取到外层的 prev 变量
  return function () {
    let now = Date.now();    
    if (now - prev >= t) {
      fn.apply(this, arguments);
      prev = now;
    }
  }
}


// 防抖
export const debounce = (fn, t) => {
  let timeout = null;
  return function () {
    if (timeout) clearTimeout(timeout);
    timeout = setTimeout(() => {
      fn.apply(this, arguments)
    }, t);
  }
}